import { acknowledgeCoBrandingBanner } from './actions';
import acceptCookies from '../cookie-banner/actions';
import { CO_BRANDING_BANNER_LOCALSTORAGE_STATE_KEY } from './constants';

export type CoBrandingBannerState = {
  isActive: boolean;
  lastAcknowledged: number | undefined;
};

type Actions =
  | ReturnType<typeof acknowledgeCoBrandingBanner | typeof acceptCookies>
  | { type: 'SESSION_RECEIVE' }
  | {
      type: 'LOCAL_STORAGE_RECEIVE';
      localStorageState: any;
    };

const initialState: CoBrandingBannerState = {
  isActive: false,
  lastAcknowledged: undefined,
};

export default (
  state: CoBrandingBannerState = initialState,
  action: Actions
) => {
  switch (action.type) {
    case 'LOCAL_STORAGE_RECEIVE':
      return {
        ...state,
        ...action.localStorageState[CO_BRANDING_BANNER_LOCALSTORAGE_STATE_KEY],
      };
    case 'SESSION_RECEIVE':
      return { ...state, isActive: true };
    case 'ACKNOWLEDGE_CO_BRANDING_BANNER':
    case 'ACCEPT_COOKIES': // Having seen the cookie banner also counts, as it contains similar information
      return { ...state, lastAcknowledged: Date.now() };
    default:
      return state;
  }
};
